module.exports = { id: "mail", url: "/build/app/img/symbols.svg#mail", viewBox: "", toString: function() { return this.url; } };